export default "__VITE_ASSET__CoGNmLqY__"